import { useState, useEffect } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

interface DisplayTextOptions {
  fromDate: Date | null;
  label: string;
  isSameUser: boolean;
  recruiterName?: string;
}

export function useInterviewDisplayTexts({ fromDate, label, isSameUser, recruiterName }: DisplayTextOptions) {
  const { t } = useTranslation('messaging');
  const [isStarted, setIsStarted] = useState(() => (fromDate ? moment().isSameOrAfter(fromDate) : false));

  // trigger the text update exactly when the interview starts
  useEffect(() => {
    if (!fromDate) return;

    const now = moment();
    const target = moment(fromDate);
    const timeUntilStart = target.diff(now);

    if (timeUntilStart <= 0) {
      setIsStarted(true);
      return;
    }

    setIsStarted(false);
    const timeoutId = setTimeout(() => {
      setIsStarted(true);
    }, timeUntilStart);

    // eslint-disable-next-line consistent-return
    return () => clearTimeout(timeoutId);
  }, [fromDate]);

  // Build the Subtitle (Time Status)
  let subtitle = '';
  if (fromDate) {
    const startMoment = moment(fromDate);
    subtitle = isStarted
      ? t('upcommingInterviewBanner.pastInterviewDate', { date: startMoment.format('h:mm A') })
      : t('upcommingInterviewBanner.upcomingInterviewDate', {
          date: startMoment.format('MMMM DD'),
          time: startMoment.format('h:mm A'),
        });
  }

  let recruiterSuffix = '';
  if (recruiterName) {
    if (isSameUser) {
      recruiterSuffix = t('upcommingInterviewBanner.yourInterview');
    } else {
      recruiterSuffix = recruiterName;
    }
  }

  const title = t(`upcommingInterviewBanner.${isStarted ? 'bannerOngoingInterview' : 'bannerUpcomingInterview'}`, {
    interviewType: label,
  });

  return { title, subtitle, recruiterSuffix };
}
